import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Group } from "../../models/group.model";
import { Integration } from "../../models/integration.model";
import { PermissionCheck } from "../../shared/permission";
import { StreetDataProvider } from "../../data-provider/street.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { NationBuilderDataProvider } from "../../data-provider/nation-builder.dp";
import { Utils } from "../../helper/utils.helper";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";

let NationBuilderComponent = {
    selector: "vcNationBuilder",
    templateUrl:
        "/angular/components/nation-builder/nation-builder.component.html",
    bindings: {},
    controller: class NationBuilderController {
        public nbWarning: any;
        public loadingNations = true;
        public nation: any = null;
        public importsInterval: any;

        public loadingLists = false;
        public lists: any[] = [];
        public importLists: any[] = [];

        private readonly $scope: any;
        private readonly $interval: any;
        private readonly $cookies: any;
        private readonly $rootScope: any;
        private readonly $window: any;
        private readonly $mdDialog: any;
        private readonly toast: ToastUtils;
        private readonly dialog: DialogUtils;
        public readonly __env: any;
        public readonly utils: Utils;

        private streetDataProvider: StreetDataProvider;
        private dataProvider: NationBuilderDataProvider;
        private campaignDataProvider: CampaignDataProvider;
        public permissionProvider: PermissionCheck;

        constructor(
            $scope: any,
            $interval: any,
            $cookies: any,
            $rootScope: any,
            $window: any,
            $mdDialog: any,
            __env: any,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            Utils: Utils,
            StreetDataProvider: StreetDataProvider,
            NationBuilderDataProvider: NationBuilderDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            PermissionCheck: PermissionCheck,
            NavigationBarHelperService: NavigationBarHelperService
        ) {
            this.$scope = $scope;
            this.$interval = $interval;
            this.$cookies = $cookies;
            this.$rootScope = $rootScope;
            this.$window = $window;
            this.$mdDialog = $mdDialog;
            this.__env = __env;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.utils = Utils;
            NavigationBarHelperService.setShowBackButton(true);

            this.streetDataProvider = StreetDataProvider;
            this.dataProvider = NationBuilderDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.permissionProvider = PermissionCheck;

            this.nbWarning = this.$cookies.get("NB_WARNING");
            if (angular.isDefined(this.nbWarning) && this.nbWarning) {
                this.$cookies.remove("NB_WARNING");
            }

            this.dataProvider.getNations().then(
                (nationsData: any) => {
                    if (nationsData.length > 0) {
                        this.nation = nationsData[0];
                        if (this.nation.nbaccesstoken) {
                            if (this.nation.confirmed == "1") {
                                let activeCampaign =
                                    this.campaignDataProvider.activeCampaign;
                                activeCampaign.nbnid = this.nation.nbnid;
                                this.campaignDataProvider.setActiveCampaign(
                                    activeCampaign
                                );
                            }

                            this.loadLists();
                        } else {
                            this.loginNation();
                        }
                    } else {
                        this.nationInfoDialog({});
                    }
                    this.loadingNations = false;
                },
                () => {
                    this.nationInfoDialog({});
                    this.loadingNations = false;
                }
            );
        }

        $onInit() {
            this.$rootScope.$on("$locationChangeSuccess", () => {
                this.$interval.cancel(this.importsInterval);
            });

            this.$scope.$watch(
                () => this.importLists,
                (newVal: any[], _: any[]) => {
                    angular.forEach(newVal, (value: any, _: number) => {
                        let nblist: any = this.listWithID(value.list_id);
                        nblist.progress = parseFloat(value.progress);
                        nblist.nbimportid = parseInt(value.nbimportid);
                        nblist.status = value.status;
                    });
                },
                true
            );
        }

        openStatusMapping(ev: any): void {
            this.dialog.show({
                component: "vc-integration-status-mapping",
                targetEvent: ev,
                clickOutsideToClose: false,
                skipHide: true,
                size: "large",
                ariaLabel: "NationBuilder Mapping",
                locals: {
                    selectedIntegration: new Integration({
                        key: "nationbuilder",
                        title: "NationBuilder",
                    }),
                },
            });
        }

        nationInfoDialog(nation: any): void {
            this.dialog
                .show({
                    component: "vc-nation-form",
                    clickOutsideToClose: false,
                    locals: {
                        nation: nation,
                    },
                })
                .then((json: object) => {
                    if (
                        !angular.isUndefined(json["redirect"]) &&
                        json["redirect"]
                    )
                        this.$window.location = json["redirect"];
                });
        }

        deleteNation(ev: any): void {
            let confirm = this.dialog
                .confirm()
                .title("Unlink your nation")
                .htmlContent(
                    "<p>By Unlinking your nation your " +
                        this.__env.product_name +
                        " " +
                        this.__env.strings.campaign +
                        " will no longer be kept in sync with your NationBuilder nation.</p>" +
                        "<p>The data will remain in your " +
                        this.__env.product_name +
                        " " +
                        this.__env.strings.campaign +
                        ".</p>"
                )
                .targetEvent(ev)
                .ok("Unlink")
                .cancel("Cancel");
            this.dialog.showPreConfiguredDialog(confirm).then(() => {
                this.dataProvider.deleteNation(this.nation).then(() => {
                    let activeCampaign =
                        this.campaignDataProvider.activeCampaign;
                    activeCampaign.nbnid = "";
                    this.campaignDataProvider.setActiveCampaign(activeCampaign);
                    this.dataProvider.clearAll();
                    this.$window.location = "/#/";
                });
            });
        }

        updateNation(nation: any): void {
            this.dataProvider.updateNation(nation); // No need to do anything. The switch acts as the success message
        }

        deleteList(list: any, ev: any): void {
            this.dialog
                .delete({
                    fullscreen: true,
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        bodyText: `This list will be permanently deleted from ${this.__env.product_name}, not NationBuilder.`,
                        title: `Delete list?`,
                    },
                })
                .then(() => {
                    this.dataProvider.deleteNBImport(list).then(
                        () => {
                            list.status = "Deleted";
                            this.toast.success("List deleted");
                        },
                        () => this.toast.error()
                    );
                });
        }

        loginNation(): void {
            const confirm = this.dialog
                .confirm()
                .title("Login to your nation")
                .textContent(
                    "You must first Login to your nation to be able to import lists. Login now?"
                )
                .ok("Login")
                .cancel("Cancel");
            this.dialog.showPreConfiguredDialog(confirm).then(() => {
                this.redirectNationLogin(this.nation);
            });
        }

        redirectNationLogin(nation: any): void {
            this.$cookies.put("CURRENT_SLUG", nation.slug, {
                domain: "." + this.__env.host,
                path: "/",
            });
            if (!angular.isUndefined(nation.redirect) && nation.redirect)
                window.location = nation.redirect;
        }

        loadLists(): void {
            this.loadingLists = true;
            this.importLists = [];
            this.dataProvider.getLists(this.nation.nbnid).then(
                (nationBuilderLists: any) => {
                    this.lists = nationBuilderLists;
                    this.getImports();
                    this.importsInterval = this.$interval(
                        this.getImports.bind(this),
                        5000
                    );
                },
                () => {
                    this.toast.error(
                        'NationBuilder Error", "We have used our limit of NationBuilder requests. Please try again later.'
                    );
                }
            );
        }

        addToGroup(list: any, ev: any): void {
            this.dialog
                .show({
                    component: "vc-group-selection-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        provider: this.streetDataProvider,
                    },
                })
                .then((group: Group) => {
                    group
                        .addMembers(
                            {
                                members: [
                                    {
                                        list_id: list.id,
                                        checked_items_count: list.count,
                                        data_type: "people",
                                    },
                                ],
                            },
                            this.dialog
                        )
                        .then(
                            (group: Group) => {
                                this.toast.success(
                                    list.name + " added to " + group.gname
                                );
                            },
                            (json: object) => {
                                if (json["message"]) {
                                    this.toast.error(json["message"]);
                                } else {
                                    this.toast.error();
                                }
                            }
                        );
                });
        }

        getImports(): void {
            this.dataProvider.getImports(this.nation.slug).then(
                (imports: any) => {
                    this.importLists = imports;
                    this.loadingLists = false;
                },
                () => {
                    this.loadingLists = false;
                }
            );
        }

        import(list: any): void {
            list.progress = 0.1;
            list.status = "In Progress";
            this.dataProvider.import(this.nation.slug, list).then(
                (importId: string) => (list.nbimportid = importId),
                () => (list.status = "Limit Exceeded")
            );
        }

        // Progress is NaN until the import worker writes its first update.
        hasProgress(list: any): boolean {
            return Number.isFinite(list.progress);
        }

        estimatedTime(list: any): string {
            const recordsPerSecond = 10;
            const sizeRemaining = list.count * ((100 - list.progress) / 100);
            const totalSeconds = sizeRemaining / recordsPerSecond;
            const totalMinutes = Math.floor(totalSeconds / 60);
            const hours = Math.floor(totalMinutes / 60);
            const minutes = Math.floor(totalMinutes % 60);
            if (hours > 0) {
                const hourString = hours > 1 ? "hours" : "hour";
                return hours + " " + hourString + " " + minutes + " minutes";
            } else if (minutes < 1) {
                return "Less than a minute";
            }
            return minutes + " minutes";
        }

        cancelImport(importItem: any): void {
            this.dataProvider
                .cancelImport(importItem)
                .then(() => (importItem.status = "Cancelled"));
        }

        listWithID(id: string | number): any[] {
            return this.lists.filter((elem: any) => elem.id == id)[0];
        }

        limitExceededInfo(list: any): void {
            if (list.status == "Limit Exceeded") {
                this.$mdDialog.show({
                    controller: "ImportErrorDialogController",
                    templateUrl:
                        "/angular/components/voter-file/importErrorDialog.html",
                    skipHide: true,
                    fullscreen: false,
                    clickOutsideToClose: true,
                });
            }
        }
    },
};

angular
    .module("nationBuilder")
    .component(NationBuilderComponent.selector, NationBuilderComponent);
